export enum TaskStatusOptions {
  Ok = 'Ok',
  NotOk = 'Not ok',
  NotApplicable = 'Not applicable',
  Blocked = 'Blocked',
}
